import { FormValues, useAppointment } from 'entities/appointment/lib/hooks/useAppointment';
import styles from './AppointmentForm.module.scss';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { Controller } from 'react-hook-form';
import { FC } from 'react';
import { bookingStore } from 'entities/booking';
import { LEGAL_INFO, PDP_POLICY_URL, USER_AGREEMENT_URL } from 'shared/consts';
import { withMask } from 'use-mask-input';

type AppointmentFormProps = {
  phone?: string;
  onChangePhone?: () => void;
  onSubmit: (vals: FormValues) => void;
  isLoading: boolean;
}

export const AppointmentForm: FC<AppointmentFormProps> = ({
  phone,
  onChangePhone,
  onSubmit,
  isLoading = false
}) => {

  const {
    errors,
    control,
    buttonText,
    buttonDisabled,
    formState,
    getValues,
    checkBtn,
    onPatronymicBoxChange,
    onDateChange,
  } = useAppointment();

  const onChangePhoneClick = () => {
    bookingStore.removePhone();

    setTimeout(() => {
      onChangePhone?.();
    }, 10);
  }

  return (
    <form className={styles.appointmentForm}>
      <div className={styles.appointmentForm__title}>Данные пациента</div>
      <div className={styles.appointmentForm__input}>
        <Controller 
          name='last_name'
          control={control}
          render={({ field }) => (
            <>
              <label>Фамилия</label>
              <input 
                type="text" 
                name={field.name}
                value={field.value}
                tabIndex={0}
                onChange={event => {
                  field.onChange(event);
                  checkBtn();
                }}
              />
            </>
          )}
        />
      </div>
      <div className={styles.appointmentForm__input}>
        <Controller 
          name='first_name'
          control={control}
          render={({ field }) => (
            <>
              <label>Имя</label>
              <input 
                type="text" 
                name={field.name}
                value={field.value}
                tabIndex={0}
                onChange={event => {
                  field.onChange(event);
                  checkBtn();
                }}
              />
            </>
          )}
        />
      </div>
      <div className={styles.appointmentForm__input}>
        <Controller 
          name='middle_name'
          control={control}
          render={({ field }) => (
            <>
              <div className={styles.appointmentForm__inputhead}>
                <label>Отчество</label>
                <label className={styles.appointmentForm__boxwrap}>
                  <input type="checkbox" tabIndex={-1} checked={formState.isPatronymicChecked} onChange={onPatronymicBoxChange} />
                  <i></i>
                  <span>Не указано в документах</span>
                </label>
              </div>
              <input 
                type="text" 
                name={field.name}
                value={field.value}
                disabled={formState.isPatronymicChecked}
                tabIndex={0}
                onChange={event => {
                  field.onChange(event);
                  checkBtn();
                }}
              />
            </>
          )}
        />
      </div>

      <Controller 
        control={control}
        name="birth_day"
        render={({field}) => (
          <div className={`${styles.appointmentForm__input} ${styles.appointmentForm__input_short}`}>
            <label>Дата рождения</label>
            <input 
              type="text" 
              ref={withMask('99.99.9999')}
              value={field.value}
              inputMode='numeric'
              onChange={(event) => onDateChange(event, field)}
              tabIndex={0}
            />
            {errors.birth_day?.message && <p>{errors.birth_day.message}</p>}
          </div>
        )}
      />

      {phone && 
      <div className={styles.appointmentForm__phoneinfo}>
        <label>Контактный телефон</label>
        <div>
          <div className={styles.appointmentForm__phone}>{phone}</div>
          <ButtonContained
            type='button'
            variant='secondary'
            className={styles.appointmentForm__changephone}
            onClick={onChangePhoneClick}
          >Указать другой</ButtonContained>
        </div>
      </div>
      }

      {LEGAL_INFO && <div className={styles.appointmentForm__text}>{LEGAL_INFO}</div>}
      <Controller 
        name='personal_agree'
        control={control}
        render={({ field }) => (
          <>
            <label className={styles.appointmentForm__boxwrap}>
              <input 
                type="checkbox" 
                name={field.name} 
                checked={field.value} 
                tabIndex={0}
                onChange={event => {
                  field.onChange(event);
                  checkBtn();
                }}
              />
              <i></i>
              <span>{PDP_POLICY_URL ? <a href={PDP_POLICY_URL} target='_blank'>Согласие на передачу персональных данных</a> :  'Согласие на передачу персональных данных'}</span>
            </label>
          </>
        )}
      />
      <Controller 
        name='conditions_agree'
        control={control}
        render={({ field }) => (
          <>
            <label className={styles.appointmentForm__boxwrap}>
              <input 
                type="checkbox" 
                name={field.name} 
                checked={field.value} 
                tabIndex={0}
                onChange={event => {
                  field.onChange(event);
                  checkBtn();
                }}
              />
              <i></i>
              <span>Ознакомлен с {USER_AGREEMENT_URL ? <a href={USER_AGREEMENT_URL} target='_blank'>условиями предоставления услуг</a> : 'условиями предоставления услуг'}</span>
            </label>
          </>
        )}
      />
      <ButtonContained
        disabled={buttonDisabled||isLoading}
        variant={buttonDisabled ? 'secondary' : 'primary'}
        isLoading={isLoading}
        className={styles.appointmentForm__button}
        onClick={event => {
          if (buttonDisabled) return;
          
          event.preventDefault();
          event.stopPropagation();
          onSubmit(getValues());
        }}
      >
        {buttonText}
      </ButtonContained>
    </form>
  )
}